module.exports = __webpack_public_path__ + "img/dice4.17103472.svg";